import React, { useState, Children, isValidElement, cloneElement } from 'react';
import PropTypes from 'prop-types';
import { Paper } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { useEffect } from 'react';

const useStyles = makeStyles((theme) => ({
  container: {
    border: (props) =>
      props.modifiable
        ? `1px solid ${theme.palette.primary.main}`
        : '1px solid #BCBCBC',
    width: '100%',
    borderRadius: 10,
    padding: '30px 24px',
    marginBottom: 24,
  },
}));

const FormContainer = ({ children }) => {
  const [modifiable, setModifiable] = useState(false);
  const classes = useStyles({ modifiable: modifiable });

  const handleClick = (event) => {
    if (event !== undefined) setModifiable(true);
    else setModifiable(!modifiable);
  };

  useEffect(() => {
    children.map((child) => {
      if ('modifiable' in child.props) {
        child.props.modifiable ? setModifiable(true) : setModifiable(false);
      }
    });
  }, [children]);

  const childrenWithProps = Children.map(children, (child) => {
    if (isValidElement(child)) {
      return cloneElement(child, {
        onClick: handleClick,
        modifiable: modifiable,
      });
    }
    return child;
  });
  return (
    <Paper elevation={0} className={classes.container}>
      {childrenWithProps}
    </Paper>
  );
};

FormContainer.propTypes = {
  children: PropTypes.node,
};

export default FormContainer;
